// FairPriceList — table of fixtures with the headline (highest-edge)
// selection per row. Markup follows the prototype's .ex-table /
// .ex-thead / .ex-row layout from fair-price-dashboard.jsx.
//
// Bound through the dashboard parent which owns useFairPriceOutputs;
// this component receives the already-grouped fixtures array. Pure
// presentation. Empty state is rendered inline so the table section
// does not collapse.

import { FairPriceCard } from "./FairPriceCard.tsx";
import type { FairPriceFixture } from "../../exchange/useFairPriceOutputs.ts";

export interface FairPriceListProps {
  readonly fixtures: readonly FairPriceFixture[];
  readonly loading: boolean;
  readonly error: string | null;
  readonly onOpen: (fixtureId: string) => void;
}

export function FairPriceList({
  fixtures,
  loading,
  error,
  onOpen,
}: FairPriceListProps): JSX.Element {
  return (
    <div className="ex-table">
      <div className="ex-thead">
        <span />
        <span>Fixture</span>
        <span>Selection</span>
        <span>Fair → Mkt</span>
        <span>Edge ↓</span>
        <span>Conf.</span>
        <span>Rec.</span>
        <span />
      </div>
      {loading && fixtures.length === 0 ? (
        <div className="ex-row" style={{ gridTemplateColumns: "1fr" }}>
          <div style={{ padding: "16px 12px", color: "var(--text-secondary)" }}>
            Loading fair-price intelligence…
          </div>
        </div>
      ) : error !== null ? (
        <div className="ex-row" style={{ gridTemplateColumns: "1fr" }}>
          <div style={{ padding: "16px 12px", color: "var(--text-secondary)" }}>
            Fair Price unavailable: {error}
          </div>
        </div>
      ) : fixtures.length === 0 ? (
        <div className="ex-row" style={{ gridTemplateColumns: "1fr" }}>
          <div style={{ padding: "16px 12px", color: "var(--text-secondary)" }}>
            No upcoming fixtures in the next 7 days have been scored yet. The Fair Price engine
            surfaces fixtures here as the daily intelligence pipeline runs.
          </div>
        </div>
      ) : (
        fixtures.map((f) => (
          <FairPriceCard key={f.fixture_id} fixture={f} onOpen={() => onOpen(f.fixture_id)} />
        ))
      )}
    </div>
  );
}
